const _constant = {};
let BASE_URL = '';

if (typeof window !== 'undefined') {
  if (API_HOST) {
    BASE_URL = API_HOST;
  }
}

BASE_URL += '/merchantpgpui';

_constant.saveUpdateUrl = `${BASE_URL}/forms/update`;
_constant.saveUpdateButtonApi = `${BASE_URL}/paymentbutton/update`;
_constant.deleteField = `${BASE_URL}/forms/delete`;
_constant.fetchTemplateFieldsForPreview = `${BASE_URL}/previews`;
_constant.saveThemePreferences = `${BASE_URL}/theme`;
_constant.saveCheckoutPreferences = `${BASE_URL}/checkout`;
_constant.updatePreference = `${BASE_URL}/checkout/merchants`;
_constant.FETCH_LINKS = `${BASE_URL}/link/fetch`;
_constant.UPDATE_LINKS = `${BASE_URL}/link/update`;
_constant.PGP = 'merchantpgpui';
_constant.THEME = 'theme';
_constant.FORM = 'form';
_constant.PREVIEW = 'preview';
_constant.BUILD = 'build';
_constant.MPASS_URL = 'https] =//mas-log.paas.paytm.com/loggw/dwcookieLogGet.do';
_constant.linkUrl = 'https] =//business.paytm.com/payment-link';
_constant.invoiceUrl = 'https] =//business.paytm.com';

_constant.BASE_URL = BASE_URL;

_constant.CUSTOM = 'Custom';
_constant.FIELD_TYPE = 'Field Type';

_constant.EDIT_FIELD = 'editFld';
_constant.RENDER_ARRAY_INDEX = 'renderArrIndx';
_constant.GIVEN_ARRAY_INDEX = 'givenArrIndx';
_constant.CUSTOM_DESC = 'Create custom field';
_constant.TEXT = 'Text';
_constant.NUMBER = 'Numeric';
_constant.DROPDOWN = 'Dropdown';
_constant.DATE = 'Date';
_constant.CUSTOM_AMOUNT = 'UserAmount';
_constant.CUSTOM_AMOUNT_MERCHANT = 'Amount';
_constant.CUSTOM_AMOUNT_FLEXIBLE = 'FlexibleAmount';
_constant.CUSTOM_AMOUNT_QUANTATIVE = 'QuantityAmount';
_constant.placeHolder = 'Select/Create Field';
_constant.Description = 'linkDescription';
_constant['Template Name'] = 'templateName';
_constant.ISCUSTOMERROR = 'isCustomError';
_constant.NOOPTIONERROR = 'noOptionError';
_constant.DISABLEADDOPNBTN = 'disableAddOpnBtn';
_constant.DATE_ORDINAL = '/';
_constant.MAX_DATE = 'Max Date';
_constant.MIN_DATE = 'Min Date';
_constant.ADD_FIELD_VALUE = 'addFieldValue';
_constant.MANDATORY_VALIDATION = 'isMandatoryValidation';
_constant.FIXED = 'Fixed amount';
_constant.QUANTITY = 'Add product or service';
_constant.FLEXIBLE = 'Customer chooses amount';
_constant.SHOR_TEXT = 'Short Text';
_constant.LONG_TEXT = 'Long Text';
_constant.FIXED_LENGTH = 'Fixed Length';
_constant.CARD_NAME = 'Debit, Credit Cards';
_constant.NB = 'NB';
_constant.UPI = 'UPI';
_constant.EMI = 'EMI';
_constant.CARD = 'CARD';
// preview constants
_constant.MID = 'MID';
_constant.TOKEN = 'TOKEN';
_constant.UNIQUEID = 'UNIQUEID';
_constant.H_ORIENTATION = 'H';
_constant.V_ORIENTATION = 'V';
_constant.CUSTOM_TEXT = 'Text';
_constant.CUSTOM_NUMBER = 'Numeric';
_constant.CUSTOM_DROPDOWN = 'Dropdown';
_constant.CUSTOM_DATE = 'Date';
_constant.PAYTM = 'PAYTM';
_constant.LOGIN = 'LOGIN';
_constant.SAVEURL = 'SAVEURL';
_constant.NONE = 'NONE';
_constant['DEFAULT_PAYMENT_BUTTON_COLOR_CODE'] = '#00b9f5';
_constant['DEFAULT_PAYMENT_BUTTON_FONT_COLOR_CODE'] = '#ffffff';
_constant['DEFAULT_PAYMENT_BUTTON_TITLE'] = 'Pay Now';
_constant.BLUE_LOGO = 'BLUE-LOGO';

_constant.CUSTOMFIELDS = {
  // name:'',
  // type: '',
  constraints: null
};

_constant.EDITFLD_OBJ = {
  name: '',
  type: '',
  hint: '',
  helpText: '',
  mandatory: '',
  constraints: '',
  orientation: 'H',
  size: '100'
};
_constant.TEXT_MIN_CHAR = 3;
_constant.TEXT_MAX_CHAR = 200;
_constant.SHORT_TEXT_MAX_CHAR = 30;
_constant.AMOUNT_MIN_VALUE = 0;
_constant.AMOUNT_MAX_VALUE = 100000000;
_constant.HELP_TEXT_MIN_CHAR = 3;
_constant.HELP_TEXT_MAX_CHAR = 50;
_constant.OPTION_NAME_MAX_CHAR = 30;
_constant.FIELD_NAME_MAX_CHAR = 30;
_constant.ALLOWED_MAX_FIELDS = 20;
_constant.TEMPLATE_NAME_MAX_CHAR = 100;
_constant['URL_MAX_CHAR'] = 500;
_constant['INFO_MAX_CHAR'] = 140;

_constant['MID'] = 'mid';
_constant['TOKEN'] = 'token';
_constant['BUTTON'] = 'button';
_constant['BUTTON_TYPES'] = {"quick":"Quick-Pay","donate":"Donate","custom":"Custom"};
_constant['INPUT_FIELD_LABEL'] = 'Field Label';
_constant['URL'] = 'URL';
_constant['URL_REGEX'] = /(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g;
_constant['BUTTON_SCREEN'] = 'BUTTON_DETAILS';
_constant['CUSTOM_SCREEN'] = 'CUSTOM_SCREEN';
_constant['DONATE_SCREEN'] = 'DONATE_SCREEN';
_constant['REVIEW_SCREEN'] =  'REVIEW_SCREEN';
_constant['BUTTON_ID'] = 'BUTTON_ID';
//Input placeholder names
_constant['INPUT_FIELD_NAME'] = 'Field Name';
_constant['MIN_DATE'] = 'Min Date';
_constant['MAX_DATE'] = 'Max Date';
_constant['INPUT_AMOUNT'] = 'Amount';
_constant['INPUT_HELP_TEXT'] = 'Help text';
_constant['CUSTOM_TYPE'] = 'Custom Type';
_constant['INPUT_AMOUNT_MIN_QUNATITY'] = 'Min Quantity';
_constant['INPUT_AMOUNT_MAX_QUNATITY'] = 'Max Quantity';
_constant['RIGHT_ARROW'] = 'Rigth Arrow';
_constant['Left_ARROW'] = 'Left Arrow';
_constant['INPUT_TEMPLATE_NAME'] = 'Template Name';
_constant['INPUT_TEMPLATE_DESCRIPTION'] = 'Description';
_constant['UMP_SUCCESS_CODE'] = '004';
_constant['UMP_SUCCESS_UPDATE_CODE'] = '009';
_constant['UMP_FAIL_CODE'] = '003';
_constant['UMP_PAGE_LOAD_CODE'] = '001';
_constant.ACTIVE = "ACTIVE";
_constant.INACTIVE = "INIT";
_constant.SUBS_MIN_AMOUNT = 1;
_constant.ONDEMAND = 'ONDEMAND';
_constant.YMD_FORMAT = 'YYYY/MM/DD';
_constant.DMY_FORMAT = 'MM/DD/YYYY';
_constant.AMOUNT_FIXED = 'FIX';
_constant.AMOUNT_VARIABLE = 'VARIABLE';
_constant.INPUT_HELP_TEXT_PLACEHOLER = 'Enter help text';
_constant.INPUT_FIELD_NAME_PLACEHOLER = 'Enter Field name';
_constant.QUANTITY_FIELD_NAME_PLACEHOLER = 'Per unit cost';

export const THEME_CONSTANTS = {
  HEADERPANEL: 'headerPanel',
  HEADERTEXT: 'headerText',
  PAYBUTTONBG: 'payButtonBG',
  PAYBUTTONTEXT: 'payButtonText',
  BODYBG: 'bodyBG',
  BODYTEXT: 'bodyText',
  LIGHT: 'LIGHT',
  DARK: 'DARK',
  CUSTOM: 'CUSTOM',
  GENERICERROR: 'Something went wrong...'
};

export const LIGHTTHEME = {
  HEADERPANEL: '#F3F7F8',
  HEADERTEXT: '#506d85',
  PAYBUTTONBG: '#00b9f5',
  PAYBUTTONTEXT: '#FFFFFF',
  BODYBG: '#FFFFFF',
  BODYTEXT: '#1D252D',
  BOTTOMBG: '#F3F7F8',
  BORDER: '#F3F7F8',
  LABEL: 'Light theme',
  NAME: 'LIGHT',
  IMAGE: 'light',
  isSelected: true
};

export const DARKTHEME = {
  HEADERPANEL: '#0d1528',
  HEADERTEXT: '#FFFFFF',
  PAYBUTTONBG: '#00b9f5',
  PAYBUTTONTEXT: '#FFFFFF',
  BODYBG: '#000a1e',
  BODYTEXT: '#FFFFFF',
  BOTTOMBG: '#000000',
  BORDER: '#0d1528',
  LABEL: 'Dark theme',
  NAME: 'DARK',
  IMAGE: 'dark',
  isSelected: false
};

export const CUSTOMTHEME = {
  HEADERPANEL: '#F3F7F8',
  HEADERTEXT: '#000000',
  PAYBUTTONBG: '#00b9f5',
  PAYBUTTONTEXT: '#FFFFFF',
  BODYBG: '#FFFFFF',
  BODYTEXT: '#1D252D',
  BOTTOMBG: '#F3F7F8',
  BORDER: '#F3F7F8',
  LABEL: 'Custom theme',
  NAME: 'CUSTOM',
  IMAGE: 'custom',
  isSelected: false
};

export const CUSTOMBAR = [
  {
    NAME: 'Header Panel',
    KEY: 'HEADERPANEL'
  },
  {
    NAME: 'Header Text',
    KEY: 'HEADERTEXT'
  },
  {
    NAME: 'Pay Button',
    KEY: 'PAYBUTTONBG'
  },
  {
    NAME: 'Pay Button Text',
    KEY: 'PAYBUTTONTEXT'
  },
  // {
  //     "NAME": "Body background color",
  //     "KEY": "BODYBG"
  // },
  {
    NAME: 'Body Text',
    KEY: 'BODYTEXT',
    DESC: '(including separators and input boxes)'
  },
  {
    NAME: 'Border',
    KEY: 'BORDER'
  }
];

export const DEFULTPAYMODES = [
  { name: 'Paytm', type: 'LOGIN', id: 1 },
  { id: 7, name: 'Credit / Debit Card', type: 'CARD' },
  { id: 9, name: 'BHIM UPI', type: 'UPI' },
  { id: 8, name: 'Net Banking', type: 'NB' }
];

export const DEFAULT_GRADIENT_COLOR = {
  degree: 0,
  direction: '',
  buttonGradientsColors: [],
  headerGradientsColors: []
};
export const DEFAULT_CHECKOUT_CONFIG = {
  root: '',
  style: {
    bodyBackgroundColor: '',
    bodyColor: '',
    themeBackgroundColor: '',
    themeColor: '',
    headerBackgroundColor: '',
    headerColor: '',
    borderColor: '',
    errorColor: '',
    successColor: '',
    gradient: JSON.parse(JSON.stringify(DEFAULT_GRADIENT_COLOR))
  },
  jsFile: '',
  data: {
    orderId: '',
    token: '',
    tokenType: 'SSO',
    mid: '',
    userDetail: { mobileNumber: 121212, name: '' }
  },
  merchant: { name: '', logo: '', redirect: true, callbackUrl: '', hidePaytmBranding: false },
  mapClientMessage: {},
  labels: {},
  payMode: { labels: {}, filter: { include: [], exclude: [] }, order: [] },
  handler: {}
};

export const SmallButtonSize = { type: "SMALL", name: "Small", font: "12px", height: "28px", lineHeight: "28px", padding: "0 23px" };
export const MediumButtonSize = { type: "MEDIUM", name: "Medium", font: "14px", height: "48px", lineHeight: "48px", padding: "0 40px" };
export const LargeButtonSize = { type: "LARGE", name: "Large", font: "16px", height: "56px", lineHeight: "56px", padding: "0 41px" };
export const QuickButton = { type: "QUICK", name: "Quick-Pay Button" };
export const DonateButton = { type: "DONATE", name: "Donate Button" };
export const customButton = { type: "CUSTOM", name: "Custom Button" };

export default _constant;



// WEBPACK FOOTER //
// ./utils/constants.js